var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"development-section",attrs:{"flex":""}},[_c('h1',[_c('i',{staticClass:"fas fa-cog fa-lg fa-spin mr-3"}),_c('span',[_vm._v("Section in development")])])])}
var staticRenderFns = []

export { render, staticRenderFns }